import axios from 'axios'

export async function uploadRevisedWeedFilesOnStorage(
  zipBlob: Uint8Array,
  url: string,
  fileName: string,
) {
  await axios.put(url, zipBlob, {
    headers: {
      'Content-Disposition': `attachment; filename=${fileName}.zip`,
      'Content-Type': 'application/octet-stream'
    }
  })
}

export async function uploadRevisedGrowLinesFilesOnStorage(
  zipBlob: Uint8Array,
  url: string,
  fileName: string,
) {
  await axios.put(url, zipBlob, {
    headers: {
      'Content-Disposition': `attachment; filename=${fileName}.zip`,
      'Content-Type': 'application/octet-stream'
    }
  })
}
